<template>
    <v-col>
        <div class="wrapper">
            <div class="wrap-filters primary">
                <v-row align="center">
                    <v-col cols="12" md="8" sm="5">
                        <h1>{{ $tc("users.users", 2) }}</h1>
                    </v-col>
                </v-row>
                <v-btn
                    color="secondary"
                    class="btn-add floating-btn"
                    elevation="0"
                    @click="showNewUserForm = true"
                >
                    <v-icon size="18">mdi-plus</v-icon>
                    {{ $t("global.add") }}
                </v-btn>
            </div>

            <div class="wrap-datables">
                <v-row>
                    <v-col cols="12" md="6" sm="12">
                        <v-text-field
                            v-model="search"
                            :label="$t('global.search')"
                            append-icon="mdi-magnify"
                            dense
                            hide-details="auto"
                            light
                            outlined
                            single-line
                        ></v-text-field>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col>
                        <v-data-table
                            :footer-props="{
                                'items-per-page-options': [
                                    25, 50, 100, 500, -1,
                                ],
                            }"
                            :headers="headers"
                            :items="users"
                            :items-per-page="25"
                            :loading="loading"
                            :search="search"
                        >
                            <template #[`item.role`]="{ item }">
                                {{ $t(`role.${item.role}`) }}
                            </template>

                            <template #[`item.actions`]="{item}">
                                <v-btn
                                    class="edit ma-1"
                                    icon
                                    small
                                    dark
                                    @click="editUser(item)"
                                    >
                                    <v-icon size="16">mdi-pencil</v-icon>
                                </v-btn>
                                <v-btn
                                    v-if="canDeleteUser(item)"
                                    class="delete ma-1"
                                    icon
                                    small
                                    dark
                                    @click="showConfirmDeleteDialog(item)"
                                >
                                    <v-icon size="16">mdi-delete</v-icon>
                                </v-btn>
                            </template>
                        </v-data-table>
                    </v-col>
                </v-row>
            </div>
        </div>

        <new-user
            :visible="showNewUserForm"
            @close="handleClose"
        >
        </new-user>

        <edit-user
            v-if="editedUser"
            :user="editedUser"
            :visible="showEditUserForm"
            @close="handleClose"
        >
        </edit-user>

        <confirm-delete
            :message="$t('users.going_to_delete', [userToDelete.lastname, userToDelete.firstname])"
            :visible="confirmDialog"
            @close="confirmDialog = false"
            @validate="deleteUser(userToDelete)"
        />
    </v-col>
</template>

<script>
import NewUser from "./new";
import EditUser from "./edit";
import {ROLE_ADMIN, ROLE_SUPER_ADMIN} from "../../../constants";
import ConfirmDelete from "../../../components/dialogs/confirmDelete";

export default {
    name: "Users",
    components: {NewUser, EditUser, ConfirmDelete},
    data() {
        return {
            users: [],
            search: "",
            headers: [
                {
                    text: this.$t("users.name"),
                    align: "start",
                    sortable: true,
                    value: "lastname",
                },
                {
                    text: this.$t("users.firstname"),
                    align: "start",
                    sortable: true,
                    value: "firstname",
                },
                {
                    text: this.$t("users.email"),
                    align: "start",
                    sortable: true,
                    value: "email",
                },
                {
                    text: this.$t("users.role"),
                    align: "start",
                    sortable: true,
                    value: "role",
                },
                {
                    text: this.$t("global.actions"),
                    align: "center",
                    sortable: false,
                    value: "actions",
                },
            ],
            showNewUserForm: false,
            showEditUserForm: false,
            loading: false,
            editedUser: null,
            confirmDialog: false,
            userToDelete: {},
        };
    },
    async mounted() {
        this.getUsers()
    },
    methods: {
        async getUsers() {
            try {
                this.loading = true
                this.users = (await this.$api.users.all()).data.data
                this.loading = false
            } catch (e) {
                this.loading = false
            }
        },
        async handleClose() {
            this.showNewUserForm = false
            this.showEditUserForm = false
            await this.getUsers()
            this.editedUser = null
        },
        editUser(user) {
            this.editedUser = user
            this.showEditUserForm = true
        },
        async deleteUser(user) {
            await this.$api.users.delete(user.id)
            this.getUsers()
            this.confirmDialog = false;
        },
        canDeleteUser(user_to_delete) {
            if (this.$auth.user().role === ROLE_ADMIN && user_to_delete.role === ROLE_SUPER_ADMIN) {
                return false;
            }

            return user_to_delete.id !== this.$auth.user().id;
        },
        showConfirmDeleteDialog(userToDelete) {
            this.confirmDialog = true;
            this.userToDelete = userToDelete;
        }
    }
}
</script>
